exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlight{z-index:1}.hide-drako{display:none}.help-module__drako-talk button{max-width:1260px;width:100%!important;height:100%!important;cursor:auto!important}.help-module__drako-talk button div.gifffer-play-button{display:none}.footer,.headline{z-index:2;position:relative}.sc_first{position:static}.sc_first__drako{top:23.5%}", ""]);

// exports
